"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  release: {
    title: 'Release Status Query',
    blNo: 'B/L No.',
    containerNo: 'Container No.',
    result: 'Search Result',
    tips_1: 'Warm Tips：',
    tips_2: '（1） Only status of "SURRENDERED" or "SEA WAYBILL ISSUED" will be displayed here and will not be updated once it\'s uploaded. If there\'s any change, agent\'s record shall be prevail. ',
    tips_3: '（2） Release status , Release time here are for reference only. If necessary please check with agent for firm information. ',
    releaseBlInfo: 'BL Release Status',
    releaseStatus: 'Release Status',
    releaseDate: 'Release Date',
    changeBlInfo: 'DO Release Status',
    changeStatus: 'Release Status',
    changeDate: 'Release Date'
  }
};